export const WEEK_DAY_ITEMS = [
  { text: "Domingo", value: 0 },
  { text: "Segunda-feira", value: 1 },
  { text: "Terça-feira", value: 2 },
  { text: "Quarta-feira", value: 3 },
  { text: "Quinta-feira", value: 4 },
  { text: "Sexta-feira", value: 5 },
  { text: "Sábado", value: 6 },
];

export const ENGLISH_LEVELS = [
  { text: "Beginner 1", value: 0 },
  { text: "Beginner 2", value: 1 },
  { text: "Essential 1", value: 2 },
  { text: "Essential 2", value: 3 },
  { text: "Pre Intermediate 1", value: 4 },
  { text: "Pre Intermediate 2", value: 5 },
  { text: "Intermediate 1", value: 6 },
  { text: "Intermediate 2", value: 7 },
  { text: "Upper 1", value: 8 },
  { text: "Upper 2", value: 9 },
  { text: "Advanced 1", value: 10 },
  { text: "Advanced 2", value: 11 },
];

const GROUP_FORMATS = {
  0: "Sozinho",
  1: "Individual",
  2: "Dupla",
  3: "Trio",
  4: "Quarteto",
  5: "Quinteto",
};

const GROUP_FREQUENCIES = {
  0: "Todos os dias",
  1: "1x por semana",
  2: "2x por semana",
  3: "3x ou mais por semana",
  4: "A cada 15 dias",
};

const GROUP_STATUS = {
  0: "Aguardando",
  1: "Ativa",
  2: "Inativa",
  3: "Rejeitada",
};

const GROUP_STATUS_COLORS = {
  0: "amber darken-2",
  1: "green darken-1",
  2: "blue-grey lighten-1",
  3: "red darken-1",
};

const PARTICIPANT_STATUS = {
  0: "Pendente",
  1: "Ativo",
  2: "Inativo",
  3: "Rejeitado",
};

export function displayGroupLevel(level) {
  return ENGLISH_LEVELS.find((item) => item.value === +level)?.text || "-";
}

export function displayGroupFormat(format) {
  return GROUP_FORMATS[+format] || "-";
}

export function displayGroupFrequency(frequency) {
  return GROUP_FREQUENCIES[+frequency] || "-";
}

export function displayGroupStatus(status) {
  return GROUP_STATUS[+status] || "-";
}

export function groupStatusColor(status) {
  return GROUP_STATUS_COLORS[+status] || "grey";
}

export function participantStatusLabel(status) {
  return PARTICIPANT_STATUS[+status] || "Sem status";
}

export function participantStatusColor(status) {
  return groupStatusColor(status);
}

const WEEK_DAY_SHORT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

export function weekDayShortLabel(weekDay) {
  return WEEK_DAY_SHORT[+weekDay] ?? "-";
}

export function formatScheduleSummary(weekDays = [], hours = []) {
  const times = normalizeClassTimes(weekDays, hours);

  if (!times.length) {
    return "Sem horário definido";
  }

  return times
    .map((time) => `${weekDayShortLabel(time.weekDay)} ${time.start}`)
    .join(" · ");
}

export function attendanceStatusLabel(status) {
  if (+status === 1) {
    return "Presente";
  }

  if (+status === 2) {
    return "Falta";
  }

  return "Pendente";
}

export function normalizeClassTimes(weekDays = [], hours = []) {
  if (!Array.isArray(weekDays) || !Array.isArray(hours)) return [];

  return weekDays.reduce((acc, day, index) => {
    const hour = hours[index];

    if (!hour || !hour.includes("-")) return acc;

    const [start, end] = hour.split("-");
    acc.push({
      weekDay: +day,
      start: start.trim(),
      end: end.trim(),
    });

    return acc;
  }, []);
}

export function initialsFromName(name) {
  if (!name) return "";

  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}

export function resolveBillingValue(student) {
  const candidate =
    student?.billing?.monthlyValue ??
    student?.currentPlan?.finalValue ??
    student?.currentPlan?.value ??
    student?.monthlyFee ??
    student?.mensalidade ??
    student?.plan?.value;

  if (candidate === undefined || candidate === null || candidate === "") {
    return null;
  }

  const numericCandidate =
    typeof candidate === "number" ? candidate : Number(candidate);

  if (!Number.isNaN(numericCandidate)) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(numericCandidate);
  }

  return `${candidate}`;
}

export function resolveTeachingPlanValue(plan) {
  if (!plan) {
    return null;
  }

  const value = Number(plan.value || 0);
  const discount = Number(plan.discount || 0);

  if (Number.isNaN(value) || Number.isNaN(discount)) {
    return null;
  }

  return Math.max(value - discount, 0);
}

export function getClassDurationValue(hours = []) {
  const firstRange = Array.isArray(hours) ? hours[0] : null;

  if (!firstRange || !firstRange.includes("-")) return null;

  const [start, end] = firstRange.split("-").map((item) => item.trim());
  const [startHour, startMinute] = start.split(":").map(Number);
  const [endHour, endMinute] = end.split(":").map(Number);

  const startTotal = startHour * 60 + startMinute;
  const endTotal = endHour * 60 + endMinute;
  const duration = endTotal - startTotal;

  if (Number.isNaN(duration) || duration <= 0) return null;

  return duration > 60 ? 2 : 1;
}

export function findMatchingTeachingPlan(plans = [], classData = {}) {
  if (!Array.isArray(plans) || !plans.length || !classData) return null;

  const classFormat = Number(classData.format);
  const classFrequency = Number(classData.frequency);

  return (
    plans.find((plan) => {
      const sameFormat = Number(plan.format) === classFormat;
      const sameFrequency = Number(plan.frequency) === classFrequency;

      return sameFormat && sameFrequency;
    }) ||
    plans.find(
      (plan) =>
        Number(plan.format) === classFormat &&
        Number(plan.frequency) === classFrequency
    ) ||
    null
  );
}
